<template>
  <Select
    :clearable="clearable === false ? false : true"
    :multiple="multiple"
    :max-tag-count="maxTagcount"
    :disabled="disabled"
    @on-change="change"
    :placeholder="placeholder || '请选择'"
    v-model="currentValue"
    :transfer="transfer || false"
  >
    <Option v-for="item in dicValues" :key="item.value" :label="item.txt" :value="item.value"></Option>
  </Select>
</template>

<script>
export default {
  props: {
    dicType: null,
    value: null,
    disabled: null,
    multiple: null,
    placeholder: null,
    clearable: null,
    transfer: null,
    filter: null,
    maxTagcount: {
      default: 1
    },
  },
  components: {},
  data() {
    return {
      dicList: [],
    };
  },
  watch: {},
  computed: {
    dicValues() {
      const dicData = JSON.parse(localStorage.dicData);
      if (!dicData || typeof dicData[this.dicType] == 'undefined') {
        return [{ txt: '', value: '' }];
      } else {
        let out = dicData[this.dicType];
        if (this.filter && this.filter.length && out && out.length) {
          out = out.filter(item => !this.filter.includes(item.code));
        }
        return out;
      }
    },
    currentValue: {
      // 动态计算currentValue的值
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  created() {
  },
  methods: {
    change(val) {
      this.$emit('change', val);
    }
  }
};
</script>
<style lang="scss"></style>
